// Edit the text on your website here. Items in [brackets] are placeholders to replace.
// Photos: put image files in /app/frontend/public/images/ and reference them as "/images/your-file.jpg".

export const company = {
  name: "Wiggins Construction LLC",
  brandName: "Wiggins",
  brandSub: "Construction LLC",
  location: "Altoona, Wisconsin",
  phone: "715-214-3121",
  phoneLink: "+17152143121",
  email: "twigginsconstruction@gmail.com",
  address: "Altoona, WI",
  serviceArea: "Eau Claire, WI and surrounding areas",
  hours: "Monday – Sunday, 7:00 AM – 9:00 PM",
};

export const navLinks = [
  { id: "home", label: "Home", path: "/" },
  { id: "services", label: "Services", path: "/services" },
  { id: "projects", label: "Projects", path: "/projects" },
  { id: "about", label: "About", path: "/about" },
  { id: "contact", label: "Contact", path: "/contact" },
];

// Social media: paste your page links between the quotes when you have them.
export const social = [
  { id: "facebook", label: "Facebook", url: "https://www.facebook.com/share/19aqSdj2jC/?mibextid=wwXIfr" },
  { id: "tiktok", label: "TikTok", url: "https://www.tiktok.com/@wiggins.construction?_r=1&_t=ZT-9ArWcebXfAs" },
];

export const home = {
  heading: "Wiggins Construction",
  headingSub: "LLC",
  intro:
    "Wiggins Construction LLC provides a wide range of residential construction, remodeling, and repair services throughout the Eau Claire area. With a focus on quality workmanship, attention to detail, and dependable service, every project is approached with care and dedication.",
  logo: "/images/logo-full.png",
  photo: "/images/tyler-wiggins-3.jpg",
  photoAlt: "Tyler Wiggins, owner of Wiggins Construction LLC",
  photoName: "Tyler Wiggins",
  photoTitle: "Owner / Contractor",
};

export const services = {
  heading: "Services",
  estimateHeading: "Free Estimates",
  estimateText: "Call, text, or email to set up a free estimate for your project.",
  intro: "From small repairs to larger construction projects, Wiggins Construction offers a wide range of residential services, including custom projects and unique requests.",
  items: [
    { title: "Interior Construction & Remodeling", description: "Kitchens, flooring, doors, trim, drywall, and interior improvements." },
    { title: "Exterior Construction & Improvements", description: "Garages, decks, stairs, framing, siding, and exterior projects." },
    { title: "Repairs & Maintenance", description: "Home repairs, property maintenance, replacements, and general improvements." },
    { title: "Demolition & Specialty Projects", description: "Demolition, removal, custom projects, and other unique requests." },
  ],
};

// To add a project: copy one { title, description, photos } block and change the text and photo files.
export const projects = {
  heading: "Projects",
  intro: "A few examples of recent work.",
  socialNote: "These are just a few of our projects. Follow us on Facebook and TikTok to see more of our work.",
  items: [
    {
      title: "Detached Garage",
      description: "Framing and all exterior work, excluding concrete.",
      photos: [
        { src: "/images/garage-1.jpg", alt: "Detached garage with gable front and siding" },
        { src: "/images/garage-2.jpg", alt: "Side view of the detached garage" },
      ],
    },
    {
      title: "Kitchen Remodel",
      description: "Cabinets and countertop installed, along with the sink and any drywall repairs.",
      photos: [
        { src: "/images/kitchen-before.jpg", alt: "Kitchen before the remodel", label: "Before" },
        { src: "/images/kitchen-after.jpg", alt: "Kitchen after the remodel with new cabinets and countertops", label: "After" },
      ],
    },
    {
      title: "Water Damage Repair",
      description: "Drywall patched and painted with new doors and trim.",
      photos: [
        { src: "/images/hallway-before.jpg", alt: "Hallway before, with open wall framing and missing doors", label: "Before" },
        { src: "/images/hallway-after.jpg", alt: "Hallway after, with patched and painted drywall, new doors and trim", label: "After" },
      ],
    },
  ],
};

export const about = {
  heading: "About",
  paragraphs: [
    "Wiggins Construction LLC is a locally owned and operated business founded by Tyler Wiggins. With over two years of hands-on construction experience and a technical diploma in Residential Construction, I bring practical knowledge, dedication, and attention to detail to every project.",
    "As an owner-operated business, I take pride in providing dependable service, maintaining a clean and respectful work environment, and treating every customer’s home and property with care. My goal is simple: deliver quality workmanship and results that customers can feel confident in.",
  ],
  qualificationsHeading: "Qualifications",
  qualifications: [
    "Wisconsin Dwelling Contractor Credential holder",
    "Fully insured for your protection and peace of mind",
    "Technical diploma in Residential Construction",
  ],
  photos: [
    // { src: "/images/project-1.jpg", alt: "Description of the project" },
  ],
};

export const contact = {
  heading: "Contact",
  intro: "Call, text, or email to discuss your project.",
};
